import type { MultiselectProps } from '@amzn/awsui-components-core/multiselect';
import type { StudioOption } from 'src/components/star-grid/reportStudio.types';
import { studioSelectOptions, studioSelectedOption } from 'src/components/star-grid/utils/studioSelect';
import type { StarGridText } from 'src/components/star-grid/hooks/useStarGridText';

export const studioSelectionSummary = (selected: readonly MultiselectProps.Option[], text: StarGridText): string => {
  if (!selected.length) return text('studioSelectValues');
  const label = selected[0].label ?? selected[0].value ?? '';
  if (selected.length === 1) return label;
  return text('studioSelectionSummary')
    .replace('{count}', String(selected.length - 1))
    .replace('{label}', () => label);
};

export const studioSelectionValues = (selected: readonly MultiselectProps.Option[]): readonly string[] =>
  selected.flatMap((option) => (option.value !== undefined ? [option.value] : []));

export const studioMultiselectPresentation = (values: readonly string[], options: readonly StudioOption[], text: StarGridText) => {
  const selectedOptions = values.map((value) => studioSelectedOption(options, value));
  return {
    selectedOptions,
    options: studioSelectOptions(options),
    summary: studioSelectionSummary(selectedOptions, text),
    tokens: selectedOptions.map((option) => ({
      label: option.label,
      dismissLabel: text('studioDeselectValue').replace('{label}', () => option.label)
    }))
  };
};
